import { Grid } from "@mui/material";
import Typography from "../Typography";
import Helpers from "../../commons/helpers";

interface IProps {
    value?: any;
    title?: string;
    valueBold?: boolean;
    titleBold?: boolean;
    isFullRow?: boolean;
}

const TitleValue = ({ isFullRow, value, title, valueBold, titleBold = true }: IProps) => {
    const titleProps = isFullRow ? { xs: 12, md: 3, lg: 3, xl: 2 } : { xs: 12, md: 6, lg: 6, xl: 4 }
    const valueProps = isFullRow ? { xs: 12, md: 9, lg: 9, xl: 10 } : { xs: 12, md: 6, lg: 6, xl: 8 }

    if (!Helpers.isNullOrEmpty(title) && !Helpers.isNullOrEmpty(value)) {
        return (
            <Grid container>
                {
                    !Helpers.isNullOrEmpty(title) &&
                    <Grid item {...titleProps}>
                        <Typography variant="button" fontWeight={titleBold ? "bold" : "light"}>{title}:</Typography>
                    </Grid>
                }
                {
                    !Helpers.isNullOrEmpty(value) &&
                    <Grid item {...valueProps}>
                        <Typography variant="button" fontWeight={valueBold ? "bold" : "light"}>{`${value}`}</Typography>
                    </Grid>
                }
            </Grid>
        )
    } else {
        return (
            <>
                {
                    !Helpers.isNullOrEmpty(title) &&
                    <Typography variant="button" fontWeight={titleBold ? "bold" : "light"}>{title}:</Typography>
                }
                {
                    !Helpers.isNullOrEmpty(value) &&
                    <Typography variant="button" fontWeight={valueBold ? "bold" : "light"}>{`${value}`}</Typography>
                }
            </>
        );
    }
}

export default TitleValue;
